import { Component, inject } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { EditProfileComponent } from '@monorepo-channels/feature-pm'
import { AbstractComponent } from '@monorepo-channels/channels/domain'
import { CommonModule } from '@angular/common'
import { MenuOpened } from '@monorepo-channels/shared/util-helpers'

@Component({
	selector: 'pm-edit-profile',
	standalone: true,
	imports: [EditProfileComponent, RouterOutlet, CommonModule],
	template: `
		<router-outlet />
		<main class="container" [ngClass]="{ 'container--sidenav-opened': menuOpened.sidenavOpened }">
			<feature-pm-edit-profile />
		</main>
	`,
	styles: `
	@import 'mixin';
	.container {
		padding: 0 20px;
		@include tablet-up {
			max-width: var(--max-width-tablet);
			margin: 0 auto;
		}
	}
	.container--sidenav-opened{
		margin: 0 40px;
	}
	`,
})
export class EditProfilePageComponent extends AbstractComponent {
	public menuOpened = inject(MenuOpened)
}
